/** Small wordmark icon — a simplified rocket nose, used next to "SateLab" in the brand panel. */
export function BrandMark() {
  return (
    <svg viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <path
        d="M16 2c4.5 3.6 7 8.9 7 14.5 0 2.6-.5 5-1.4 7.2l-5.6 4.3-5.6-4.3C9.5 21.5 9 19.1 9 16.5 9 10.9 11.5 5.6 16 2Z"
        fill="var(--brand-primary)"
      />
      <circle cx="16" cy="14" r="2.6" fill="var(--brand-dark)" />
    </svg>
  );
}
